import { env } from '@/env';

/**
 * Il QGammon di QUESTA build, per `tavoloDaAprireOf`: `env.qgammonWsUrl` se il backgammon e' acceso
 * (la rotta `/backgammon/match/:id` esiste solo li'), altrimenti `null` — e nessun tavolo si apre.
 * Una definizione sola per i tre posti che offrono il tavolo: il riquadro della partita esterna, il
 * bottone unico dell'incontro e la barra dell'azione persistente.
 */
export const servizioTavoliDellaBuild = (): string | null =>
  env.featureBackgammonEnabled ? env.qgammonWsUrl : null;
